import { render, staticRenderFns } from "./TodayActivity.vue?vue&type=template&id=23570cb7&scoped=true&"
import script from "./TodayActivity.vue?vue&type=script&lang=js&"
export * from "./TodayActivity.vue?vue&type=script&lang=js&"
import style0 from "./TodayActivity.vue?vue&type=style&index=0&id=23570cb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23570cb7",
  null
  
)

export default component.exports